import { ASSETS_WITHOUT_LABELS_VIEW, TAXONOMY_VIEW_PARAM } from '@/pages/TaxonomyPage/TaxonomyPage';

export type RecommendationSignals = {
  isTaxonomyEnabled: boolean;
  isPartFinderEnabled: boolean;
  canManageTaxonomy: boolean;
  assetsTotal: number;
  unlabeledAssets: number;
  hasCompletedDuplicationReport: boolean;
};

export type Recommendation = {
  id: string;
  title: string;
  pitch: (signals: RecommendationSignals) => string;
  callToAction: { label: string; path: string };
  isApplicable: (signals: RecommendationSignals) => boolean;
};

export const MAX_RECOMMENDATIONS = 3;

const assetCountFormat = new Intl.NumberFormat();

const describeUnlabeledAssets = (count: number): string => {
  const subject = count === 1 ? 'asset has' : 'assets have';
  return `${assetCountFormat.format(count)} ${subject} no label yet.`;
};

export const recommendationCatalogue: Recommendation[] = [
  {
    id: 'label-assets',
    title: 'Label your assets',
    pitch: ({ unlabeledAssets }) => describeUnlabeledAssets(unlabeledAssets),
    callToAction: {
      label: 'Open taxonomy',
      path: `taxonomy?${TAXONOMY_VIEW_PARAM}=${ASSETS_WITHOUT_LABELS_VIEW}`,
    },
    isApplicable: ({ isTaxonomyEnabled, canManageTaxonomy, unlabeledAssets }) =>
      isTaxonomyEnabled && canManageTaxonomy && unlabeledAssets > 0,
  },
  {
    id: 'duplication-report',
    title: 'Find duplicate parts',
    pitch: () => 'You have not run a duplication report.',
    callToAction: { label: 'New report', path: 'report' },
    isApplicable: ({ assetsTotal, hasCompletedDuplicationReport }) => assetsTotal > 0 && !hasCompletedDuplicationReport,
  },
  {
    id: 'part-finder',
    title: 'Try Part Finder',
    pitch: () => 'Look up a part number to find sourcing options.',
    callToAction: { label: 'Look up a part', path: 'part-finder' },
    isApplicable: ({ isPartFinderEnabled }) => isPartFinderEnabled,
  },
  {
    id: 'visual-search',
    title: 'Search by photo',
    pitch: () => 'Upload a photo of a part to find matches.',
    callToAction: { label: 'Try it', path: 'assets' },
    isApplicable: ({ assetsTotal }) => assetsTotal > 0,
  },
];

export const selectRecommendations = (catalogue: Recommendation[], signals: RecommendationSignals): Recommendation[] =>
  catalogue.filter(entry => entry.isApplicable(signals)).slice(0, MAX_RECOMMENDATIONS);
